// config.ts
// Central config for API base URL and environment

import { debugLog } from './utils/debugLogger';

// Get API base URL from environment variables (set in vite.config.ts)
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || '/fleet/api/v1';

// Detect if we're in Docker/production environment
const isDocker = import.meta.env.VITE_DOCKER === 'true';
const isProd = import.meta.env.MODE === 'production' || isDocker;

// Use environment-specific API base URL
export const API_BASE = isProd 
  ? "https://cloud.jamie.gg/fleet-api/api/v1"  // Production URL
  : apiBaseUrl;  // Dev URL from environment variable

export const IMG_BASE = "";

// For debugging
debugLog(`[Config] Environment: ${isProd ? 'Production' : 'Development'}`);
debugLog(`[Config] API Base URL: ${API_BASE}`);
debugLog(`[Config] Current Origin: ${window.location.origin}`);

// Helper for API calls that adds proper CORS headers
export const fetchWithCors = async (url: string, options: RequestInit = {}) => {
  const fetchOptions: RequestInit = {
    ...options,
    credentials: 'include',
    headers: {
      ...options.headers,
      'Content-Type': 'application/json',
      'Origin': window.location.origin,
    }
  };
  
  console.log(`[API] Fetching: ${url}`);
  try {
    const response = await fetch(url, fetchOptions);
    console.log(`[API] Response status: ${response.status}`);
    return response;
  } catch (error) {
    console.error(`[API] Error fetching ${url}:`, error);
    throw error;
  }
};
